<template>
  <div class="pc_container app-main-content">
    <div class="app-main-content-section bgfff">
      <div class="flex mb24 pb16">
        <el-input placeholder="请输入姓名/证件号/电话" prefix-icon="el-icon-search" v-model="keyword"
          class="select-inpw mr16"></el-input>
        <el-button type="primary" @click="search">搜索</el-button>
        <div class="flex flex_items">
          <!-- <div class=" page_main_bg cf pointer handle-btn mr16" @click="addNew">
            <img src="@/assets/index/ad-icon.png" alt="" class="mini-icon" style="margin-right: 4px;">
            <span class="l1">添加</span>
          </div> -->
        </div>
      </div>
      <div>
        <el-table :data="list" style="width: 100%" :header-cell-style="{
          background: '#F3F3F3',
          color: '#1F3349',
          fontSize: '15px',
          fontWeight: 'normal',
        }" :cell-style="{ fontSize: '15px', color: '#666666' }" @selection-change="handleSelectionChange">
          <!-- :index="indexMethod" type="index"-->
          <!-- <el-table-column
            prop="id"
            label="序号"
            align="left"
            width="110"
          >
          </el-table-column> -->
          <!-- <el-table-column type="selection" width="100">
          </el-table-column> -->
          <!-- <el-table-column prop="id" label="ID" width="110">
          </el-table-column> -->
          <el-table-column prop="name" label="姓名">
          </el-table-column>
          <el-table-column prop="phone" label="电话">
          </el-table-column>
          <el-table-column prop="code" label="证件号">
          </el-table-column>

          <el-table-column prop="code" label="证件类型">
            <template slot-scope="scope">
              <div class="flex">
                <div class="s-icon" :class="'s-icon' + scope.row.type">
                  {{ tourist_certificate[scope.row.certificate] }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="start_time" label="会员卡开始时间">
          </el-table-column>
          <el-table-column prop="end_time" label="会员卡结束时间">
          </el-table-column>

          <!-- <el-table-column prop="date" label="填报时间">
            <template slot-scope="scope">
              <div class="flex">
                <div class="s-icon" :class="'s-icon' + scope.row.type">
                  {{ scope.row.type == 1 ? '填报' : '不填报' }}
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="remarks" label="备注">
          </el-table-column>
          <!-- 操作 -->
          <!-- <el-table-column fixed="right" align="center" label="操作" width="200">
            <template slot-scope="scope">
              <div class="flex flex_items flex_center">
                <div @click="handleClick(scope.row)" class="main_color pointer page-handle-btn">
                  详情
                </div>
              </div>
            </template>
          </el-table-column> -->
          <div slot="empty" style="text-align: center;width:100%">
            暂无数据
          </div>
        </el-table>

        <div class="flex flex_end pagination" v-if="total > 10">
          <el-pagination background layout="prev, pager, next,sizes,jumper" :total="total"
            @current-change="currentChange" :current-page="currentPage" :page-size="pageSize" @size-change="pageSizeC">
          </el-pagination>
        </div>

      </div>

      <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :show-close="true" title="会员详情"
        :visible.sync="dialogVisible" width="30%">
        <div class="flex flex_items f14 mb24">
          <div style="width:70px" class="txt_right mr10 flex_shrink"><span class="color-red">*</span> 填报类型</div>
          <el-radio-group v-model="type" class="">
            <el-radio label="1">填报</el-radio>
            <el-radio label="2">不填报</el-radio>
          </el-radio-group>
        </div>
        <div class="flex flex_items f14 mb24">
          <div style="width:70px" class="txt_right mr10 flex_shrink"><span class="color-red">*</span> 填报时间</div>
          <el-date-picker v-model="value1" type="date" placeholder="选择日期" class="flex1">
          </el-date-picker>
        </div>
        <div class="flex flex_items f14">
          <div style="width:70px" class="txt_right mr10 flex_shrink"> 备注</div>
          <el-input placeholder="请输入" v-model="remarks" :rows="2"></el-input>
        </div>
        <!-- <div slot="footer" class="dialog-footer flex flex_items f14 flex_end">
          <div class="sub_btn page_main_bg cf" @click="handleSure">立即提交</div>
        </div> -->
      </el-dialog>

    </div>

  </div>
</template>
<script>
import { PUBLICURL } from '@/utils/index'
import { pageSize } from '@/utils/tool';
export default {
  data() {
    return {
      list: [],
      PUBLICURL: PUBLICURL,
      check: 0,
      dialogVisible: false,
      total: 0,
      currentPage: 1,
      pageSize: pageSize,
      keyword: '',
      choseArr: [],
      val: '',
      handleId: '',

      query: {},
      id: '',
      type: '1',
      remarks: '',
      value1: '',
      tourist_certificate: {}
    };
  },
  watch: {
    // keyword() {
    //   this.currentPage = 1;
    //   this.getList()
    // },

  },
  // beforeRouteLeave(to, from, next) {
  //   if (leftList.filter(r => r.path == to.path).length != 0) {
  //     to.meta.proName = from.meta.proName
  //   }
  //   next(vm => {
  //   });
  // },
  methods: {
    search() {
      this.currentPage = 1;
      this.getList()
    },
    indexMethod(e) {
      return (e + 1) + this.pageSize * (this.currentPage - 1)
    },
    addNew() {
      this.handleId = '';
      this.val = '';
      this.dialogVisible = true
    },

    getList() {
      this.api.getUrl('/api/v1/window/yearCard/list', {
        size: this.pageSize,
        page: this.currentPage,
        keyword: this.keyword,
      }, { loading: true }, this.id)
        .then((res) => {
          this.list = res.list;
          this.tourist_certificate = res.tourist_certificate
          this.total = res.meta.total;
        });
    },
    currentChange(e) {
      this.currentPage = e
      this.getList();
    },
    pageSizeC(e) {
      this.pageSize = e;
      this.getList()
    },
    // handleClick(e) {
    //   this.handleId = e.id;
    //   this.api.getUrl('/api/v1/window/yearCard/detail/'+e.id, {loading:true}).then(res => {

    //   })

    //   this.dialogVisible = true;
    // },
    handleSelectionChange(e) {
      this.choseArr = e;
    },

  },
  created() {
    this.id = this.$route.query.id;
    this.query = this.$route.query;
    this.getList()
  },
};
</script>
<style scoped>
.list-items {
  width: 266px;
  height: 150px;
  background: #F5F7FA;
  border-radius: 8px 8px 8px 8px;
  box-sizing: border-box;
}

.icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}

.page_title {
  margin-bottom: 24px;
}

.label.label1 {
  color: #67C23A;
  background: rgba(103, 194, 58, .29);
}

.label {
  padding: 2px 6px;
  background: rgba(64, 158, 255, .29);
  border-radius: 4px;
}

.t-btn {
  margin-right: 40px;
  position: relative;
}

.t-btn.main_color::after {
  position: absolute;
  bottom: -24px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #409EFF;
  content: " ";
}

.s-icon {
  border-radius: 4px 4px 4px 4px;
  padding: 2px 7px;
}

.s-icon1 {
  background: rgba(64, 158, 255, .29);
  color: rgba(64, 158, 255, 1);
}

.s-icon2 {
  background: rgba(245, 108, 108, .29);
  color: rgba(245, 108, 108, 1);
}
</style>
<style>
.el-progress__text {
  font-size: 13px !important;
}
</style>